<template>
  <div>
    <div class="container-fluid page-login">
      <div>
        <v-row class="row-logo ml-6 mt-3 mb-4">
          <img class="logo" src="../assets/logo-rozenbal.png" alt="logo" />
        </v-row>
      </div>
      <div fill-height class="mainbglogin">
        <v-row class="d-flex flex-row justify-end row-container-form-login">
          <v-col cols="4" class="container-login-form">
            <h1 class="h1">Générateur de catalogues</h1>
            <div ref="part1" v-show="currentPart=='part1'">
              <v-form>
                <m-form-text
                  placeholder="Email / identifiant"
                  label-position="top"
                  v-model="co_login"
                  name="login"
                  autocomplete
                ></m-form-text>
                <div class="d-flex flex-row row-input-password">
                  <m-form-text
                    :type="inputPassxordType"
                    placeholder="Mot de passe"
                    label-position="top"
                    v-model="co_password"
                    autocomplete
                    name="password"
                  ></m-form-text>
                  <div v-if="inputPassxordType === 'password'" @click="inputPassxordType = 'text'">
                    <icon class="withpointer ml-3" name="eye"></icon>
                  </div>
                  <div v-if="inputPassxordType === 'text'" @click="inputPassxordType = 'password'">
                    <icon class="withpointer ml-3" name="eye-slash"></icon>
                  </div>
                </div>
                <v-alert :type="alert_type" ref="alert" v-if="alert_txt">{{alert_txt}}</v-alert>
                <v-btn class="btn-login" @click="login()">Se connecter</v-btn>
                <div>
                  <a class="ml-2 text-blue" @click="currentPart='part2'">Mot de passe oublié</a>
                </div>
              </v-form>
            </div>

            <div ref="part2" v-show="currentPart=='part2'">
              <v-form class="mt-3">
                <m-form-text
                  label="Identifiant ou Email"
                  label-position="top"
                  v-model="co_login"
                  name="login"
                  autocomplete
                ></m-form-text>
              </v-form>
              <v-alert
                :type="alert_type_part2"
                ref="alert"
                v-if="alert_txt_part2"
              >{{alert_txt_part2}}</v-alert>
              <div>
                <v-btn color="secondary" @click="currentPart='part1'" class="mr-2">Annuler</v-btn>
                <v-btn
                  color="black"
                  @click="sendPassword"
                  class="ml-auto"
                  style="color:white;"
                >Envoyer le mot de passe</v-btn>
              </div>
            </div>

            <div ref="part3" v-show="currentPart=='part3'">
              Vous allez recevoir un mail le plus rapidement possible, vous permettant de mettre à jour votre mot de passe.
              <div>
                <v-btn
                  color="black"
                  @click="currentPart='part1'"
                  class="ml-auto"
                  style="color:white"
                >Se connecter maintenant</v-btn>
              </div>
            </div>

            <div ref="part4" v-show="currentPart=='part4'">
              <div v-if="!alert_txt_part4">
                <m-form-text
                  type="password"
                  label="Nouveau mot de passe"
                  label-position="top"
                  v-model="co_password1"
                  autocomplete
                  name="password"
                ></m-form-text>
                <m-form-text
                  type="password"
                  label="Retaper votre mot de passe"
                  label-position="top"
                  v-model="co_password2"
                  autocomplete
                  name="password"
                ></m-form-text>
                <v-btn
                  color="black"
                  @click="newpassword"
                  class="ml-auto"
                >Redéfinir le nouveau mot de passe</v-btn>
              </div>
              <v-alert
                :type="alert_type_part4"
                ref="alert"
                v-if="alert_txt_part4"
              >{{alert_txt_part4}}</v-alert>
            </div>

            <div ref="part5" v-show="currentPart=='part5'">
              C'est bon !
              <br />Votre nouveau mot de passe a été définit.
              <br />Vous pouvez maintenant vous connecter.
              <div>
                <v-btn
                  color="black"
                  @click="currentPart='part1'"
                  class="ml-auto"
                >Se connecter maintenant</v-btn>
              </div>
            </div>
          </v-col>
        </v-row>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "login",
  components: {},
  mounted() {
    this.$root.$children[0].hideMenus();
    this.$root.$children[0].resizeMainContainer();

    if (this.$route.name == "resetpass") {
      this.currentPart = "part4";
      this.checkchallenge(
        this.$route.params.co_id,
        this.$route.params.challenge
      );
    }
  },
  data() {
    return {
      currentPart: "part1",
      co_login: "",
      co_password: "",
      alert_txt: "",
      alert_type: "warning",
      inputPassxordType: "password",

      co_password1: "",
      co_password2: "",
      alert_txt_part2: "",
      alert_type_part2: "warning",
      alert_txt_part4: "",
      alert_type_part4: "warning",
      challenge_newpassword: "",
      co_id: ""
    };
  },
  methods: {
    async newpassword() {
      if (!this.challenge_newpassword) return;
      let response = await this.$axios.post(
        this.$config.server_url + "/api/1.0/signin/forgetpassword/newpassword",
        {
          co_password: this.co_password1,
          co_id: this.co_id,
          challenge: this.challenge_newpassword
        }
      );
      if (response.data.err) {
        this.alert_txt_part4 = "Erreur de challenge";
      } else {
        this.currentPart = "part5";
      }
    },
    async checkchallenge(co_id, challenge) {
      this.co_id = co_id;
      let response = await this.$axios.post(
        this.$config.server_url +
          "/api/1.0/signin/forgetpassword/checkchallenge",
        { co_id, challenge }
      );
      if (response.data.err) {
        this.alert_txt_part4 = "Erreur de challenge";
      } else {
        // this.currentPart = "part3";
        this.challenge_newpassword = response.data.data.challenge;
      }
    },
    async sendPassword() {
      let response = await this.$axios.post(
        this.$config.server_url + "/api/1.0/signin/forgetpassword",
        { co_login: this.co_login }
      );
      if (response.data.err) {
        this.alert_txt_part2 =
          "Nous n'avons pas pu retrouver votre identifiant";
      } else {
        this.currentPart = "part3";
      }
    },
    async login() {
      try {
        let response = await this.$axios.post(
          this.$config.server_url + "/api/1.0/signin",
          { co_login: this.co_login, co_password: this.co_password }
        );
        if (response.data.err) {
          //console.log("response.data.err", response.data.err);
          this.alert_txt = "Erreur de connexion";
          this.alert_type = "warning";
          return;
        }
        this.alert_txt = "Vous êtes connecté";
        this.alert_type = "success";
        // this.$store.commit("set_token", response.data.token);
        // this.$store.commit("set_refreshtoken", response.data.refreshtoken);
        // this.$store.commit("set_user", response.data.data);
        // console.log("response.data", response.data);

        this.$store.commit("set_connexion", {
          token: response.data.token,
          refreshtoken: response.data.refreshtoken,
          user: response.data.data,
          preferences: response.data.preferences
        });
        this.$root.$children[0].showMenus();
        this.$router.push("/home");
      } catch (error) {
        console.error("error", error);
        this.alert_txt = "Erreur!!!";
        this.alert_type = "warning";
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.page-login {
  height: 100vh;
}
.logo {
  width: 100px;
}
#rozenbal .mainbglogin {
  background-image: url(/img/homme-twist-rozenbal.jpg);
  background-size: cover;
  background-position: center;
  padding: 0;
  margin: 0;
  height: 100%;
}
.row-container-form-login {
  align-items: center;
  height: 100%;
}
.container-login-form {
  background-color: #ffffff8f;
  margin-right: 50px;
  padding: 50px 60px;
}
.h1 {
  font-size: 50px;
  color: #454545; // $gris-fonce
  line-height: initial;
  margin-bottom: 20px;
}
#rozenbal .btn-login {
  background-color: #c10a1e; // $red
  color: #fff;
  border-radius: 20px;
  padding: 10px 30px;
  width: 50%;
}
form div:first-child {
  width: 60%;
}
.row-input-password {
  align-items: center;
  margin-bottom: 20px;
  div:first-child {
    width: 60%;
  }
}
</style>